import { API_BASE_URL } from './api';
export async function placementRequest<T>(path:string,token:string,method='GET',body?:unknown):Promise<T>{
 const response=await fetch(`${API_BASE_URL}${path}`,{method,headers:{Authorization:`Bearer ${token}`,'Content-Type':'application/json'},cache:'no-store',...(body===undefined?{}:{body:JSON.stringify(body)})});
 const data=await response.json();
 if(!response.ok)throw Object.assign(new Error(data.message||'Permintaan gagal. Coba lagi.'),{status:response.status,saved_attempt:data.saved_attempt});
 return data;
}
